import { createUseStyles } from 'react-jss';
import { ITheme } from '@quicktools/shared-components';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      backgroundColor: 'var(--x-bg-1)',
      paddingTop: 40,
    },
    imageSection: {
      marginBlockEnd: 0,
    },
  }),
  { name: 'Landing' },
);
